import React, { useCallback } from "react";
import { Select } from "../select";

export const BusinessTaxSelect = ({ input, options, ...props }) => {
	const findOption = useCallback(
		() => options.find(o => o.value === input.value),
		[options, input],
	);
	return (
		<Select
			{...props}
			input={input}
			options={options}
			value={findOption(input.value)}
		/>
	);
};
